export default {
    RqScrollContainer: {
        scrollStart: "rq-scroll-container::scroll-start",
        scrollToElement: "rq-scroll-container::scroll-to-element",
    }
};